<template>
  <div class="service_box">
    <img class="qrcode" src="@/assets/wx_qrcode.png" alt="">
    <div>晓风客服</div>
    <div>周一至周五</div>
    <div>10:00 ~ 17:30</div>
  </div>
</template>

<script setup>

</script>

<style lang="less" scoped>
@import './index.less';
</style>